import React from 'react'
import './TierRequirements.css';


function TierRequirements() {
    return (
        <div className="allNew bootstrap-scope">
         

            <div className="card m-5">
            <div className="card-header">
                <h1 id="tier-2-requirements">TIER 2 requirements</h1>
            </div>
            <div className="card-body">                            
                <div className="text-center mb-5">
                    <h5 className="mb-4">TIER 2 Requirements for Medium-Voltage Transformers</h5>

                    <div className="mb-3">
                        This document outlines the TIER 2 requirements for medium-voltage transformers as well as the minimum energy efficiency requirements for large transformers.<br></br>
                        The maximum permissible losses for kVA ratings that fall between the values specified in Tables 1, 4, and 7 are determined by linear interpolation.<br></br>
                        If applicable, the correction factors listed in Tables 2 and 5 can be applied to the load and no-load losses for medium-voltage transformers with specific combinations of winding voltages at a rated power of less than 3,150 kVA.<br></br>
                        For medium-voltage transformers with dual voltage on one or both windings, where the voltages differ by more than 10% and the rated power is ≤ 3,150 kVA, the correction factors listed in Tables 3, 6, and 8 can be applied to the load and no-load losses. The losses are to be calculated based on the voltage of the winding indicated in the second column and may be increased by the correction factors given in the last two columns. In any case, the losses, regardless of the combinations of winding voltages, must not exceed the values specified in Tables 1, 4, and 7, corrected by the factors in Tables 3, 6, and 8.<br></br>
                        The minimum PEI values for MVA ratings that fall between the ratings in Tables 9, 10, and 11 are to be calculated by linear interpolation.<br></br>

                    </div>                   
                </div>
                </div>
                </div>
                <div className="bg-secondary text-white">
            <h2>Requirements for Three-Phase Medium Power Transformers</h2>
            </div>
            <div className="card m-5">
                <div className="card-header">
                    <h3><strong>Liquid-immersed medium power transformers</strong></h3>
                    <p className="text-justify">Maximum load and no-load losses (in W) for three-phase liquid-immersed medium power transformers with one winding with Um ≤ 24 kV and the other one with Um ≤ 3.6 kV</p>

                </div>
                    <div className="card-body p-4">        
                    <table className="table table-striped table-bordered text-center">
                        <thead className="thead-dark">
                            <tr>
                                <th></th>
                                <th colspan="2">TIER 2 requirements on July 1, 2021</th>
                            </tr>
                            <tr>
                                <th>Rated power [kVA]</th>
                                <th>Maximum load losses Pk (W)</th>
                                <th>Maximum no-load losses P0 (W)</th>
                            </tr>
                        </thead>  
                            <tbody>
                            <tr>
                                <td>&lt;= 25</td>
                                <td>Ak (600)</td>
                                <td>A0 -10% (63)</td>
                            </tr>
                            <tr>
                                <td>50</td>
                                <td>Ak (750)</td>
                                <td>A0 -10% (81)</td>
                            </tr>
                            <tr>
                                <td>100</td>
                                <td>Ak (1.250)</td>
                                <td>A0 -10% (130)</td>
                            </tr>
                            <tr>
                                <td>160</td>
                                <td>Ak (1.750)</td>
                                <td>A0 -10% (189)</td>
                            </tr>
                            <tr>
                                <td>250</td>
                                <td>Ak (2.350)</td>
                                <td>A0 -10% (270)</td>
                            </tr>
                            <tr>
                                <td>315</td>
                                <td>Ak (2.800)</td>
                                <td>A0 -10% (324)</td>
                            </tr>
                            <tr>
                                <td>400</td>
                                <td>Ak (3.250)</td>
                                <td>A0 -10% (387)</td>
                            </tr>
                            <tr>
                                <td>500</td>
                                <td>Ak (3.900)</td>
                                <td>A0 -10% (459)</td>
                            </tr>
                            <tr>
                                <td>630</td>
                                <td>Ak (4.600)</td>
                                <td>A0 -10% (540)</td>
                            </tr>
                            <tr>
                                <td>800</td>
                                <td>Ak (6.000)</td>
                                <td>A0 -10% (585)</td>
                            </tr>
                            <tr>
                                <td>1.000</td>
                                <td>Ak (7.600)</td>
                                <td>A0 -10% (693)</td>
                            </tr>
                            <tr>
                                <td>1.250</td>
                                <td>Ak (9.500)</td>
                                <td>A0 -10% (855)</td>
                            </tr>
                            <tr>
                                <td>1.600</td>
                                <td>Ak (12.000)</td>
                                <td>A0 -10% (1.080)</td>
                            </tr>
                            <tr>
                                <td>2.000</td>
                                <td>Ak (15.000)</td>
                                <td>A0 -10% (1.305)</td>
                            </tr>
                            <tr>
                                <td>2.500</td>
                                <td>Ak (18.500)</td>
                                <td>A0 -10% (1.575)</td>
                            </tr>
                            <tr>
                                <td>3.150</td>
                                <td>Ak (23.000)</td>
                                <td>A0 -10% (1.980)</td>
                            </tr>
                            </tbody>
                        </table>
                
                        <div>
                    <div>
                        <hr></hr>
                        <p><u>Correction factors for dual voltage transformers</u></p>
                        <p>Medium power transformers with dual voltage in one or both windings
                            differing more than 10% and rated power &lt;= 3,150 kVA.</p>
                        <table class="table table-striped table-bordered">
                            <thead class="thead-dark">
                                <tr>
                                    <th>Type of dual voltage</th>
                                    <th>Reference voltage for the application of correction factors</th>
                                    <th>Load losses Pk</th>
                                    <th>No-load losses P0</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Dual voltage on one winding AND full rated power available on both windings, i.e., the full nominal power is available regardless of the combination of voltages.</td>
                                    <td>The losses shall be calculated based on the higher voltage of the dual voltage winding.</td>
                                    <td>10 %</td>
                                    <td>15 %</td>
                                </tr>
                                <tr>
                                    <td>Dual voltage on both windings AND rated power available on all combinations of windings, i.e., both voltages on one winding are fully rated in combination with one of the voltages on the other windings.</td>
                                    <td>The losses shall be calculated based on the higher voltages of both dual voltage windings.</td>
                                    <td>20 %</td>
                                    <td>20 %</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    </div>
            </div>
</div>
            <div className="card m-5">
                <div className="card-body">
            <h3><strong>Dry-type medium
                power transformers</strong></h3>
            <p>Maximum load and no-load losses (in W) for three-phase medium power
                transformers with one winding with Um ≤ 24 kV and the other one with Um
                ≤ 3.6 kV.</p>
            <table className="table table-striped table-bordered text-center">
               
                <thead>
                <tr>
                    <th></th>
                    <th colspan="2">TIER 2 requirements on July 1, 2021</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Rated power [kVA]</td>
                    <td>Maximum load losses Pk (W)</td>
                    <td>Maximum no-load losses Pk (W)</td>
                </tr>
                <tr>
                    <td>&lt;= 50</td>
                    <td>Ak (1.500)</td>
                    <td>A0 -10% (180)</td>
                </tr>
                <tr>
                    <td>100</td>
                    <td>Ak (1.800)</td>
                    <td>A0 -10% (252)</td>
                </tr>
                <tr>
                    <td>160</td>
                    <td>Ak (2.600)</td>
                    <td>A0 -10% (360)</td>
                </tr>
                <tr>
                    <td>250</td>
                    <td>Ak (3.400)</td>
                    <td>A0 -10% (468)</td>
                </tr>
                <tr>
                    <td>400</td>
                    <td>Ak (4.500)</td>
                    <td>A0 -10% (675)</td>
                </tr>
                <tr>
                    <td>630</td>
                    <td>Ak (7.100)</td>
                    <td>A0 -10% (990)</td>
                </tr>
                <tr>
                    <td>800</td>
                    <td>Ak (8.000)</td>
                    <td>A0 -10% (1.170)</td>
                </tr>
                <tr>
                    <td>1.000</td>
                    <td>Ak (9.000)</td>
                    <td>A0 -10% (1.395)</td>
                </tr>
                <tr>
                    <td>1.250</td>
                    <td>Ak (11.000)</td>
                    <td>A0 -10% (1.620)</td>
                </tr>
                <tr>
                    <td>1.600</td>
                    <td>Ak (13.000)</td>
                    <td>A0 -10% (1.980)</td>
                </tr>
                <tr>
                    <td>2.000</td>
                    <td>Ak (16.000)</td>
                    <td>A0 -10% (2.340)</td>
                </tr>
                <tr>
                    <td>2.500</td>
                    <td>Ak (19.000)</td>
                    <td>A0 -10% (2.790)</td>
                </tr>
                <tr>
                    <td>3.150</td>
                    <td>Ak (22.000)</td>
                    <td>A0 -10% (3.420)</td>
                </tr>
                </tbody>
            </table>
            <hr></hr>
            <p><u>Correction factors depend on the highest equipment voltage</u></p>
            <table className="table table-striped table-bordered text-center">
                
                <thead>
                <tr>
                    <th colspan="2"></th>
                    <th>Load losses Pk</th>
                    <th>No-load-losses P0</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Primary highest voltage for equipment Um = 36 kV</td>
                    <td>Secondary highest voltage for equipment Um ≤ 3,6 kV</td>
                    <td>10 %</td>
                    <td>15 %</td>
                </tr>
                <tr>
                    <td>Primary highest voltage for equipment Um = 36 kV</td>
                    <td>Secondary highest voltage for equipment Um &gt; 3,6 kV</td>
                    <td>10 %</td>
                    <td>20 %</td>
                </tr>
                </tbody>
            </table>
            <hr></hr>
            <p><u>Correction factors for dual voltage transformers</u></p>
            <p>Medium power transformers with dual voltage in one or both windings
                differing more than 10% and rated power &lt;= 3,150 kVA.</p>
            <table className="table table-striped table-bordered text-center">
    <thead className="thead-dark">
        <tr>
            <th>Type of dual voltage</th>
            <th>Reference voltage for the application of correction factors</th>
            <th>Load losses Pk</th>
            <th>No-load losses P0</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>
                Dual voltage on one winding
                AND
                Full rated power available on both windings, i.e., the full nominal power is available regardless of the combination of voltages.
            </td>
            <td>
                The losses shall be calculated based on the higher voltage of the dual voltage winding.
            </td>
            <td>10 %</td>
            <td>15 %</td>
        </tr>
        <tr>
            <td>
                Dual voltage on both windings
                AND
                Rated power available on all combinations of windings, i.e., both voltages on one winding are fully rated in combination with one of the voltages on the other windings.
            </td>
            <td>
                The losses shall be calculated based on the higher voltages of both dual voltage windings.
            </td>
            <td>20 %</td>
            <td>20 %</td>
        </tr>
    </tbody>
</table>
</div>
</div>
            <div className="card m-5">
                <div className="card-body">

            <p><strong><br/>
            </strong></p>
            <h3><strong>Pole-mounted
                medium power transformers with power ratings between 25 kV and 400
                kVA</strong></h3>
            <p>Maximum load and no-load losses (in W) for medium power liquid
                immersed pole-mounted transformers.</p>
            <table className="table table-striped table-bordered text-center">                
                <thead>
                <tr>
                    <th></th>
                    <th colspan="2">TIER 2 requirements on July 1, 2021</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Rated power [kVA]</td>
                    <td>Maximum load losses Pk (W)</td>
                    <td>Maximum no-load losses Pk (W)</td>
                </tr>
                <tr>
                    <td>25</td>
                    <td>Bk (725)</td>
                    <td>A0 (70)</td>
                </tr>
                <tr>
                    <td>50</td>
                    <td>Bk (875)</td>
                    <td>A0 (90)</td>
                </tr>
                <tr>
                    <td>100</td>
                    <td>Bk (1.475)</td>
                    <td>A0 (145)</td>
                </tr>
                <tr>
                    <td>160</td>
                    <td>Ck +32% (3,102)</td>
                    <td>C0 -10% (270)</td>
                </tr>
                <tr>
                    <td>200</td>
                    <td>Bk (2,333)</td>
                    <td>A0 (310)</td>
                </tr>
                <tr>
                    <td>250</td>
                    <td>Bk (2.750)</td>
                    <td>A0 (360)</td>
                </tr>
                <tr>
                    <td>315</td>
                    <td>Bk (3.250)</td>
                    <td>A0 (440)</td>
                </tr>
                </tbody>
            </table>
            <hr></hr>
            <p><u>Correction factors for dual voltage transformers</u></p>
            <p>Medium power transformers with dual voltage in one or both windings
                differing more than 10% and rated power &lt;= 3,150 kVA.</p>
            <table className="table table-striped table-bordered text-center">
    <thead className="thead-dark">
        <tr>
            <th>Type of dual voltage</th>
            <th>Reference voltage for the application of correction factors</th>
            <th>Load losses Pk</th>
            <th>No-load losses P0</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>
                Dual voltage on one winding
                AND
                Full rated power available on both windings, i.e., the full nominal power is available regardless of the combination of voltages.
            </td>
            <td>
                The losses shall be calculated based on the higher voltage of the dual voltage winding.
            </td>
            <td>10 %</td>
            <td>15 %</td>
        </tr>
        <tr>
            <td>
                Dual voltage on both windings
                AND
                Rated power available on all combinations of windings, i.e., both voltages on one winding are fully rated in combination with one of the voltages on the other windings.
            </td>
            <td>
                The losses shall be calculated based on the higher voltages of both dual voltage windings.
            </td>
            <td>20 %</td>
            <td>20 %</td>
        </tr>
    </tbody>
</table>
</div>
</div>
<div className="bg-secondary text-white">
<h2>Minimum energy efficiency requirements for large power transformers</h2>
</div>
            <div className="card m-5">
                <div className="card-body">
            
            <h3><strong>Liquid-immersed large power transformers</strong></h3>
            <table className="table table-striped table-bordered text-center">                
                <thead>
                <tr>
                    <th></th>
                    <th>TIER 2 requirements on July 1, 2021</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Rated Power (MVA)</td>
                    <td>Minimum Peak Efficiency Index (%)*</td>
                </tr>
                <tr>
                    <td>&lt;= 0,025</td>
                    <td>98,251</td>
                </tr>
                <tr>
                    <td>0,05</td>
                    <td>98,891</td>
                </tr>
                <tr>
                    <td>0,1</td>
                    <td>99,093</td>
                </tr>
                <tr>
                    <td>0,16</td>
                    <td>99,191</td>
                </tr>
                <tr>
                    <td>0,25</td>
                    <td>99,283</td>
                </tr>
                <tr>
                    <td>0,315</td>
                    <td>99,320</td>
                </tr>
                <tr>
                    <td>0,4</td>
                    <td>99,369</td>
                </tr>
                <tr>
                    <td>0,5</td>
                    <td>99,298</td>
                </tr>
                <tr>
                    <td>0,63</td>
                    <td>99,437</td>
                </tr>
                <tr>
                    <td>0,8</td>
                    <td>99,473</td>
                </tr>
                <tr>
                    <td>1</td>
                    <td>99,484</td>
                </tr>
                <tr>
                    <td>1,25</td>
                    <td>99,487</td>
                </tr>
                <tr>
                    <td>1,6</td>
                    <td>99,494</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>99,502</td>
                </tr>
                <tr>
                    <td>2,5</td>
                    <td>99,514</td>
                </tr>
                <tr>
                    <td>3,15</td>
                    <td>99,518</td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>99,532</td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>99,548</td>
                </tr>
                <tr>
                    <td>6,3</td>
                    <td>99,571</td>
                </tr>
                <tr>
                    <td>8</td>
                    <td>99,593</td>
                </tr>
                <tr>
                    <td>10</td>
                    <td>99,615</td>
                </tr>
                <tr>
                    <td>12,5</td>
                    <td>99,640</td>
                </tr>
                <tr>
                    <td>16</td>
                    <td>99,663</td>
                </tr>
                <tr>
                    <td>20</td>
                    <td>99,684</td>
                </tr>
                <tr>
                    <td>25</td>
                    <td>99,700</td>
                </tr>
                <tr>
                    <td>31,5</td>
                    <td>99,712</td>
                </tr>
                <tr>
                    <td>40</td>
                    <td>99,724</td>
                </tr>
                <tr>
                    <td>50</td>
                    <td>99,734</td>
                </tr>
                <tr>
                    <td>63</td>
                    <td>99,745</td>
                </tr>
                <tr>
                    <td>80</td>
                    <td>99,758</td>
                </tr>
                <tr>
                    <td>100</td>
                    <td>99,770</td>
                </tr>
                <tr>
                    <td>125</td>
                    <td>99,780</td>
                </tr>
                <tr>
                    <td>160</td>
                    <td>99,790</td>
                </tr>
                <tr>
                    <td>&gt;= 200</td>
                    <td>99,797</td>
                </tr>
                </tbody>
            </table>
            </div>
</div>
            <div className="card m-5">
                <div className="card-body">
            <h3 id="section"></h3>
            <h3><strong>Dry-type
                large power transformers with Um ≤ 36 kV</strong></h3>
            <table className="table table-striped table-bordered text-center">                
                <thead>
                <tr>
                    <th></th>
                    <th>TIER 2 requirements on July 1, 2021</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Rated Power (MVA)</td>
                    <td>Minimum Peak Efficiency Index (%)*</td>
                </tr>
                <tr>
                    <td>3,15&lt; Sr &lt;= 4</td>
                    <td>98,382</td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>98,387</td>
                </tr>
                <tr>
                    <td>6,3</td>
                    <td>99,389</td>
                </tr>
                <tr>
                    <td>8</td>
                    <td>99,390</td>
                </tr>
                <tr>
                    <td>&gt;= 10</td>
                    <td>99,390</td>
                </tr>
                </tbody>
            </table>
            </div>
</div>
            <div className="card m-5">
                <div className="card-body">
            <h3><strong>Dry-type
                large power transformers with Um &gt; 36 kV</strong></h3>
            <table className="table table-striped table-bordered text-center">                
                <thead>
                <tr>
                    <th></th>
                    <th>TIER 2 requirements on July 1, 2021</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Rated Power (MVA)</td>
                    <td>Minimum Peak Efficiency Index (%)*</td>
                </tr>
                <tr>
                    <td>&lt;= 0,05</td>
                    <td>96,590</td>
                </tr>
                <tr>
                    <td>0,1</td>
                    <td>97,790</td>
                </tr>
                <tr>
                    <td>0,16</td>
                    <td>98,016</td>
                </tr>
                <tr>
                    <td>0,25</td>
                    <td>98,345</td>
                </tr>
                <tr>
                    <td>0,4</td>
                    <td>98,570</td>
                </tr>
                <tr>
                    <td>0,63</td>
                    <td>98,619</td>
                </tr>
                <tr>
                    <td>0,8</td>
                    <td>98,745</td>
                </tr>
                <tr>
                    <td>1</td>
                    <td>98,837</td>
                </tr>
                <tr>
                    <td>1,25</td>
                    <td>98,892</td>
                </tr>
                <tr>
                    <td>1,6</td>
                    <td>98,960</td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>98,996</td>
                </tr>
                <tr>
                    <td>2,5</td>
                    <td>99,045</td>
                </tr>
                <tr>
                    <td>3,15</td>
                    <td>99,097</td>
                </tr>
                <tr>
                    <td>4</td>
                    <td>99,225</td>
                </tr>
                <tr>
                    <td>5</td>
                    <td>99,265</td>
                </tr>
                <tr>
                    <td>6,3</td>
                    <td>99,303</td>
                </tr>
                <tr>
                    <td>8</td>
                    <td>99,356</td>
                </tr>
                <tr>
                    <td>10</td>
                    <td>99,385</td>
                </tr>
                <tr>
                    <td>12,5</td>
                    <td>99,422</td>
                </tr>
                <tr>
                    <td>16</td>
                    <td>99,464</td>
                </tr>
                <tr>
                    <td>20</td>
                    <td>99,513</td>
                </tr>
                <tr>
                    <td>25</td>
                    <td>99,564</td>
                </tr>
                <tr>
                    <td>31,5</td>
                    <td>99,592</td>
                </tr>
                <tr>
                    <td>40</td>
                    <td>99,607</td>
                </tr>
                <tr>
                    <td>50</td>
                    <td>99,623</td>
                </tr>
                <tr>
                    <td>&gt;= 63</td>
                    <td>99,626</td>
                </tr>
                </tbody>
            </table>
            </div>
</div>
        
        </div>      
        );
    
    }

    export default TierRequirements